import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ProfileSelect } from '@client/components/listingForm/ProfileSelect';
import { ReturnProfileDialog } from '@client/components/listingForm/ReturnProfileDialog';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { ReturnPolicyType } from '@heirloom/common/constants';
import { useState } from 'react';
export const ReturnProfileSelect = ({ shopShortId, profiles, onAddProfile, value, onChange, disabled, }) => {
    const apiClient = useApiClient();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(ProfileSelect, { items: profiles.map((p) => ({
                    value: String(p.id),
                    label: p.name,
                })), value: value, onChange: onChange, onClickAdd: () => setDialogOpen(true), disabled: disabled }), _jsx(ReturnProfileDialog, { open: dialogOpen, onClose: () => setDialogOpen(false), existingNames: profiles.map((p) => p.name), saving: saving, onConfirm: async (p) => {
                    setSaving(true);
                    const result = await callApi(apiClient.shopManager.createReturnProfile({
                        params: { shopId: shopShortId },
                        body: {
                            name: p.name,
                            policyType: p.policy.type,
                            returnWindowDays: p.windowDays ?? null,
                            policyDescrRichText: p.policy.type === ReturnPolicyType.CUSTOM ? p.policy.text : null,
                        },
                    }));
                    setSaving(false);
                    if (result.error !== null) {
                        toastError('Failed to create return profile.');
                        return;
                    }
                    const d = result.data;
                    const profile = {
                        id: String(d.id),
                        name: d.name,
                        windowDays: d.returnWindowDays ?? undefined,
                        policy: d.policyType === ReturnPolicyType.CUSTOM
                            ? { type: ReturnPolicyType.CUSTOM, text: d.policyDescrRichText ?? '' }
                            : d.policyType === ReturnPolicyType.NO_RETURNS
                                ? { type: ReturnPolicyType.NO_RETURNS }
                                : { type: ReturnPolicyType.STANDARD },
                    };
                    onAddProfile(profile);
                    onChange(profile.id);
                    setDialogOpen(false);
                } })] }));
};
